export default function GarageDoorServices() {
  const services = [
    {
      icon: 'ri-door-open-line',
      title: 'Garage Door Installation',
      description: 'Professional installation of new garage doors including automatic openers, custom designs, and energy-efficient models for homes and businesses.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Garage Door Repair',
      description: 'Expert repair services for broken springs, damaged panels, malfunctioning openers, and track alignment issues with same-day service available.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Opener Installation & Repair',
      description: 'Installation and repair of automatic garage door openers including smart home integration, remote controls, and safety sensor systems.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Spring Replacement',
      description: 'Fast and safe replacement of torsion and extension springs with high-quality parts and lifetime warranty on workmanship.'
    },
    {
      icon: 'ri-service-line',
      title: 'Maintenance Services',
      description: 'Comprehensive maintenance including lubrication, safety inspections, balance adjustments, and preventive care to extend door lifespan.'
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Emergency Repairs',
      description: '24/7 emergency repair services for urgent issues including broken doors, security concerns, and safety hazards requiring immediate attention.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Garage Door Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From installation to emergency repairs, our contractors provide complete garage door solutions for every need and budget.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-6 hover:shadow-lg transition-shadow border border-gray-200">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
